// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609230434/js/" + chunkId + "." + {"44":"3547cbaa","225":"2bfe31bd","481":"b6ab6b79","486":"de681ce9","770":"b55e3fae"}[chunkId] + ".0.6760767120687269.chunk.js";
};